<template>
    <span v-if="content" ref="el" class="form-label-hint" tabindex="0">
        <i class="fa-solid fa-circle-question"></i>
    </span>
</template>

<script setup>
import {ref, watch, nextTick, onMounted, onBeforeUnmount} from 'vue';
import {Popover} from 'bootstrap';

/**
 * Question-mark icon with the field's description as a Bootstrap popover.
 *
 * The global popover initialisation in General/Setup.js only sees markup present at
 * page load, so Vue-rendered triggers have to manage their own Popover instance.
 * Rendered into body to escape the form's clip-path / overflow.
 */
const props = defineProps({
    /** Pre-rendered HTML (paragraphs), empty string hides the icon */
    content: {type: String, default: ''},
});

const el = ref(null);
let popover = null;

function create() {
    if (!el.value || !props.content) return;
    popover = new Popover(el.value, {
        content: props.content,
        html: true,
        trigger: 'hover focus',
        placement: 'top',
        container: 'body',
    });
}

function destroy() {
    popover?.dispose();
    popover = null;
}

onMounted(create);

watch(() => props.content, async () => {
    destroy();
    await nextTick();
    create();
});

onBeforeUnmount(destroy);
</script>
